import React from "react";
import { useState } from "react";
import { Button, Table } from "antd";
// import './TableTimecardFollowup.css'
import "../../GlobalCss/SPF/TableTimecardFollowup.css"

const EmployeeCareGrid = () => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const columns = [
        {
            title: 'Client',
            key: 'client',
        },
        {
            title: 'CSA',
            key: 'csa',
        },
        {
            title: 'EE',
            key: 'ee',
        },
        {
            title: 'Email',
            key: 'email',
        },
        {
            title: 'ECS',
            key: 'ecs',
        },
        {
            title: 'Work State',
            key: 'work state',
        },
        {
            title: 'TC Status',
            key: 'tc status',
        },
        {
            title: 'ST',
            key: 'st',
        },
        {
            title: 'DT',
            key: 'dt',
        },
        {
            title: 'OT',
            key: 'ot',
        },
        {
            title: 'OTHER',
            key: 'other',
        },
        {
            title: 'Week Ending',
            key: 'week ending',
        },
        {
            title: 'TimeCard Coordinator',
            key: 'timecard coordinator',
        },
        {
            title: 'CS Director',
            key: 'cs director',
        },
        {
            title: 'CSM',
            key: 'csm',
        },
        {
            title: 'Notes',
            key: 'notes',
        },
        {
            title: 'Action',
            key: 'action',
        },
    ];
    const onSelectChange = (newSelectedRowKeys) => {
        console.log('selectedRowKeys changed: ', newSelectedRowKeys);
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    return (
        <>
            <div className="timesheet-table-div">
                <Table
                    className="timesheet-table"
                    columns={columns}
                    bordered
                    rowSelection={rowSelection}
                    pagination
                />
            </div>
        </>
    )
}
export default EmployeeCareGrid;